import { BsContext } from '@app/transaction/consts';
import { useQuery } from '@tanstack/react-query';
import { Country } from '@app/types';
import { GET_COUNTRIES } from '../../queries';

interface UseCountriesResult {
  allCountries?: Country[];
  topCountries?: Country[];
  countriesLoading: boolean;
}

const useCountries = (
  context: BsContext,
  vertical?: string,
): UseCountriesResult => {
  const { data, isLoading } = useQuery(
    ['chk.getCountries', { context, vertical }],
    GET_COUNTRIES,
    {
      enabled: !!context,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      select: (data) => {
        const all = data?.all ?? [];
        const top = data?.top ?? [];

        const allCountries = all.filter(Boolean);
        const topCountries = top.filter(Boolean);

        return {
          allCountries,
          topCountries,
        };
      },
    },
  );

  return {
    ...data,
    countriesLoading: isLoading,
  };
};

export default useCountries;
